import {
  AGENTIC_LOGIC_DATA_SURFACE_OFF,
  type AgenticLogicDataSurface,
} from "@intelligems/ig-utils";

/**
 * What the acting user may author against the org-data surface (datasets and
 * Sources), for every place that builds rule types: Monaco, and the creation
 * context the authoring model reads.
 */
export interface AgenticLogicDataSurfaceState {
  /**
   * Whether the answer is final: the user's admin status is known and, for an
   * admin, the dataset keys have been read (successfully or not). The rule
   * workspace mounts only once this is true, so an admin's editor never
   * flashes red squiggles under `sdk.getDataset` calls.
   */
  settled: boolean;
  /**
   * An admin's dataset list could not be read. The surface stays on with no
   * keys, so every `sdk.getDataset` call reports an error until a reload.
   */
  datasetsFailed: boolean;
  dataSurface: AgenticLogicDataSurface;
}

/**
 * The org-data surface is for Intelligems admins only. A merchant — or a user
 * whose admin status is not known yet — authors without it, and the dataset
 * list is never read for them (its route refuses members).
 */
export const deriveAgenticLogicDataSurface = ({
  isAdmin,
  datasets,
}: {
  isAdmin: boolean | undefined;
  datasets: {
    isFetched: boolean;
    isError: boolean;
    keys: readonly string[];
  };
}): AgenticLogicDataSurfaceState => {
  if (isAdmin !== true) {
    return {
      settled: isAdmin === false,
      datasetsFailed: false,
      dataSurface: AGENTIC_LOGIC_DATA_SURFACE_OFF,
    };
  }
  return {
    settled: datasets.isFetched,
    datasetsFailed: datasets.isError,
    dataSurface: { enabled: true, datasetKeys: datasets.keys },
  };
};
